<!--出库单据详情-->
<template>
	<div class="content">
		<h3>出库单据详情</h3>
		<div class="item">
			<el-form class="outListQry-form" style="padding: 4px 50px;">
				<el-row :gutter="12">
					<el-col :span="8">
						<el-form-item label="出库单号：">{{ outstoreinfo.Order }}</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="创建时间：">{{ outstoreinfo.AddTime }}</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="12">
					<el-col :span="8">
						<el-form-item label="单据类型：">{{ outstoreinfo.OutType }}</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="更新时间：">{{ outstoreinfo.OutTime }}</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="12">
					<el-col :span="8">
						<el-form-item label="出库库房：">{{ outstoreinfo.ShipperName }}</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="操作员：">{{ outstoreinfo.OperUser }}</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="12">
					<el-col :span="8">
						<el-form-item label="经销商：">{{ outstoreinfo.ReceiverName }}</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="备注：">{{ outstoreinfo.Remark }}</el-form-item>
					</el-col>
				</el-row>
                <el-row :gutter="12" style=" margin-left: 0px; margin-right: 0px; ">
					<el-button type="primary" @click="$router.go(-1)">返回</el-button>
				</el-row>
			</el-form>
			<el-table :data="productinfogrid" highlight-current-row class="bg-white">
				<el-table-column align="center" property="ProductCodeName" label="产品名称"></el-table-column>
				<el-table-column align="center" property="SpecName" label="产品包装比例"></el-table-column>
				<el-table-column align="center" label="单据计划量">
					<el-table-column align="center"
					prop="Pnum_cs"
					label="三级">
					</el-table-column>
					<el-table-column align="center"
					prop="Pnum_sb"
					label="二级">
					</el-table-column>
					<el-table-column align="center"
					prop="Pnum_pc"
					label="一级">
					</el-table-column>
				</el-table-column>
				<el-table-column align="center" property="Shortname" label="实际数量">
					<el-table-column align="center"
					prop="CardNums"
					label="三级">
					</el-table-column>
					<el-table-column align="center"
					prop="CaseNums"
					label="二级">
					</el-table-column>
					<el-table-column align="center"
					prop="BoxNums"
					label="一级">
					</el-table-column>
				</el-table-column>
				<el-table-column align="center" property="Norms" label="处理成功数量">
					<el-table-column align="center"
					prop="Hnum_cs"
					label="三级">
					</el-table-column>
					<el-table-column align="center"
					prop="Hnum_sb"
					label="二级">
					</el-table-column>
					<el-table-column align="center"
					prop="Hnum_pc"
					label="一级">
					</el-table-column>
				</el-table-column>
				<el-table-column align="center" label="具体数码">
					<template slot-scope="scope">
						<el-button type="text" @click="showcode(scope)">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background
			@current-change="handleCurrentproductPageChange"
			layout="total,prev, pager, next,jumper"
			:total="productpageNum"
			:page-size="20">
			</el-pagination>
		</div>
        <el-dialog
			title="数码详情"
			:visible.sync="dialogVisible"
			width="840px">
			<el-table :data="codeData" highlight-current-row>
				<el-table-column align="center" width="200" property="Code" label="操作数码"></el-table-column>
				<el-table-column align="center" width="100" property="Package" label="包装层级"></el-table-column>
				<el-table-column align="center" width="100" property="Unit" label="包装单位"></el-table-column>
				<el-table-column align="center" width="200" property="OrderCode" label="单据号"></el-table-column>
				<el-table-column align="center" width="200" property="ProductName" label="产品名称"></el-table-column>
			</el-table>
            <el-pagination background
			@current-change="handleCurrentcodePageChange"
			layout="total,prev, pager, next,jumper"
			:total="codepageNum"
			:page-size="20">
			</el-pagination>
		</el-dialog>
	</div>
</template>

<script>
export default {
    name: 'OutListDetails',
	data(){
		return {
            dialogVisible:false,
			productform: {
				timestate: '', //时间类型
				starttime:'',  //起始时间
				endtime: '',   //结束时间
				odd: '',       //出库单号
				product: '',   //产品名称
				productnum:'', //产品编号
				outstore:'',   //出库库房
				outstate:'',   //出库类型
				num:'',        //数码
				checked1: false,  //单据类型选择
				checked2: false,  //单据类型选择
            },
            codeform:{
                odd: '', //出库单号
				productnum:'',  //产品编号
            },

			outstoreinfo:{
				Order:'',//出库单号
				AddTime:'',//创建时间
				OutType:'',//出库类型
				OutTime:'',//出库时间
				ShipperName:'',//发货单位
				OperUser:'',//操作员
				ReceiverName:'',//收货单位
				Remark:'',//备注
			},
			productinfogrid:[],
			productpageIndex:1,
            productpageNum:0,

            codeData:[],
            codepageIndex:1,
            codepageNum:0
		}
    },
    created() {
        this.outstoreinfo=this.$route.query.outstoreinfo;
        this.productform.odd=this.outstoreinfo.Order;
        this.selProductInfo()
    },
	methods:{
		handleCurrentproductPageChange(index){
			this.productpageIndex=index;
			this.selProductInfo()
		},
		selProductInfo(){
            var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/ViewOrderDetail.ashx',
				params:{
					action:"ViewOutOrderDetail",
					qry: this.productform,
					cid:user.QyNum,
					pageIndex:this.productpageIndex
				}
			})
			.then(res=>{
				console.log(res)
				if(res.Code==0){
					this.productinfogrid=res.Data.DataList
					this.productpageNum=res.Data.Total
				}else{
					this.$message({
						showClose: true,
						message: res.Msg,
						type: "warning"
					});
				}
			})
        },

        handleCurrentcodePageChange(index){
			this.codepageIndex=index;
			this.selCodeInfo()
		},
        showcode(scope){
            this.codeform.odd=scope.row.Order
            this.codeform.productnum=scope.row.ProductCode
            this.selCodeInfo();
        },
        selCodeInfo(){
            var user = JSON.parse(sessionStorage.getItem('user'));
            this.$axios({
				method: 'post',
				url:'/FW/ViewCodeDetail.ashx',
				params:{
					action:"ViewOutCodeDetail",
					qry: this.codeform,
					cid:user.QyNum,
					pageIndex:this.codepageIndex
				}
			})
			.then(res=>{
				console.log(res)
				if(res.Code==0){
					this.codeData=res.Data.DataList
                    this.codepageNum=res.Data.Total
                    this.dialogVisible=true
				}else{
					this.$message({
						showClose: true,
						message: res.Msg,
						type: "warning"
					});
				}
			})
        }
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:0 80px;
}
.el-form--inline .el-form-item{
    width:300px;
    margin-bottom: 10px;
}
.el-input,.el-select {
	width:200px;
}
.el-checkbox{
    line-height: 19px;
}
</style>
<style>
.bg-white .el-table__header tr:last-child th {
	background: #F5F7FA;
}
.outListQry-form {
	border: 1px solid #66b1ff;
	padding: 4px 5px;
}
.outListQry-form .el-form-item{
	margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/OutListDetails.vue